<!-- 获取图片信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody:{
                "parkingCode": "2017072401000070302888",
                "operType": "0",
                "actionType": "0",
                "picType": "0"
            },
            responseCode: {
                "data": {
                    "parkCode": "2KM43Y461",
                    "pictureList": []
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台获取停车信息的图片资源",
                t_url: this.commonUrls.test+"getPicture",
                p_url: this.commonUrls.prod+"getPicture",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车流水号' },
                        { info1: 'operType', info2: '是', info3: 'int', info4: '0-正常开闸 1-异常开闸' },
                        { info1: 'actionType', info2: '否', info3: 'int', info4: '0-进场 1-出场' },
                        { info1: 'picType', info2: '否', info3: 'int', info4: '0-车牌 1-车身' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'pictureList', info2: '是', info3: 'JSONArray', info4: '图片数据' }
                        ]
                },{
                    titleName: 'pictureList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'operType', info2: '是', info3: 'int', info4: '0-正常开闸 1-异常开闸' },
                        { info1: 'actionType', info2: '是', info3: 'int', info4: '0-进场 1-出场' },
                        { info1: 'picType', info2: '是', info3: 'int', info4: '0-车牌 1-车身' },
                        { info1: 'picData', info2: '是', info3: 'String', info4: '图片数据（base64字符串),jpg图片' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/yard/getPicture.vue